module.exports = __webpack_public_path__ + "fonts/light.4a87157b.woff";